// Color theme (light / dark / system), token-level per the Design System
// Runtime. Preference persists in localStorage; a pre-paint script in index.html
// applies it before first render to avoid a flash of the wrong theme.

export type Theme = "light" | "dark" | "system";

export const THEME_KEY = "RecruitTrucker.theme";

export function isTheme(v: unknown): v is Theme {
  return v === "light" || v === "dark" || v === "system";
}

export function getTheme(): Theme {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return isTheme(v) ? v : "system";
  } catch {
    return "system";
  }
}

/** Apply the theme by setting (or clearing, for "system") the root data-theme.
 *  "system" clears the attribute so the prefers-color-scheme media query — and
 *  live OS changes — govern. */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", theme);
}

export function setTheme(theme: Theme): void {
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    /* ignore storage failures */
  }
  applyTheme(theme);
}
